import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/pro-solid-svg-icons'

import Box from '../Box'

const Checkbox = (props) => {
  const {
    boxProps, checked, color, fontSize, iconChecked, iconDefault, onClick, marginRight, style,
  } = props

  const colorChecked = color || 'green'
  const checkedIcon = iconChecked || faCheckCircleSolid
  const icon = iconDefault || faCheckCircle

  return (
    <Box
      color={checked ? colorChecked : 'lightGrey'}
      fontSize={fontSize}
      onClick={onClick}
      marginRight={marginRight}
      style={{ cursor: 'pointer', ...style }}
      width="auto"
      {...boxProps}
    >
      <FontAwesomeIcon icon={checked ? checkedIcon : icon} />
    </Box>
  )
}

Checkbox.propTypes = {
  boxProps: PropTypes.object,
  checked: PropTypes.bool,
  color: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconChecked: PropTypes.object,
  iconDefault: PropTypes.object,
  marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  style: PropTypes.object,
}

Checkbox.defaultProps = {
  fontSize: 'large',
  marginRight: 'large'
}

export default Checkbox
